module.exports = __webpack_public_path__ + "media/images/products/retailers-customised-4-reserve-459b96434dc144b38391b991596392b0.jpg";